import LoadingIndicator from './LoadingIndicator';

export default function FullScreenLoadingIndicator() {
  return (
    <div className="fixed left-0 top-0 z-[200] h-screen w-screen bg-black bg-opacity-30">
      <LoadingIndicator />
    </div>
  );
}
